<template>
  <div>
    <p>Loading...</p>
  </div>
</template>

<script>
export default {
  methods: {
    handleLoginEvent (data) {
      // this.$router.push(data.state.target || '/')
    }
  },
  created () {
    var self = this
    this.$auth.handleAuthentication().then(function () {
      self.$router.push('/')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Callback.vue